import './Contact.css'
import CustomForm from '../../helper/CustomForm'
import { useAuthContext } from '../../hooks/useAuthContext'
import { useState } from 'react'
import { sendEmailToLezzt } from '../../helper/helper'
import { useToast } from '../../hooks/useToast'

export default function Contact() {

    const { showToast, toast } = useToast(2000)
    
    const { user } = useAuthContext()

    // console.log(user);
    

    const [dName, setDName] = useState(user ? user.displayName : "Guest")
    const [message, setMessage] = useState("")
    const [email, setEmail] = useState("")
    const [isPending, setIsPending] = useState(false)

    const resetForm=(message)=>{
        setIsPending(false)
        setMessage("")
        setDName(user ? user.displayName : "Guest")
        if(message === "OK"){
            showToast({message: 'Message Sucessfully sent!'})
        }else{
            showToast({message: 'Something went wrong... please try again later'})
        }

    }

    const handleSubmit =e=>{
        e.preventDefault()
        sendEmailToLezzt({
            sender: {
                displayName: user ? user.displayName : "Guest",
                name: dName,
                uid: user ? user.uid : "guestid"
            },
            message: message,
            callback: resetForm,
            email: email
        })
        setIsPending(true)
    }
    return (
        <div className="contact-container flex-col-center-start">
            {toast}
            <h1>Contact Us</h1>
            <p>Have any comments? suggestions? new features you want to see? or any violent reactions? feel free to send us a message!</p>

            <CustomForm 
                handleSubmit={handleSubmit}
                className=""
                // title="Help me"
            >
                <div className="field">
                    <span>Name</span>
                    <input type="text" value={dName} onChange={e=> setDName(e.target.value)} required/>
                </div>
                <div className="field">
                    <span>Email</span>
                    <input type="email" value={email} onChange={e=> setEmail(e.target.value)} required/>
                </div>
                <div className="field">
                    <span>Message</span>
                    <textarea value={message} onChange={e=> setMessage(e.target.value)} placeholder="Max 1000 characters" maxLength="1000" required></textarea>
                </div>
                {isPending ? <button disabled>Sending</button> : <button>Submit</button>}
                

            </CustomForm>

            <br />
            <span>Lezzt &copy; 2021</span>


        </div>

    )
}
